export function buildGuideJsonLd(guide) {
  const sectionUrl = (id) => `${guide.url}/${id}`;

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://ahavibes.xyz/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: guide.headline.split(":")[0],
            item: guide.url,
          },
        ],
      },
      {
        "@type": "ItemList",
        name: `${guide.headline} — Contents`,
        numberOfItems: guide.sections.length,
        itemListElement: guide.sections.map((section) => ({
          "@type": "ListItem",
          position: section.position,
          name: section.name,
          url: sectionUrl(section.id),
          description: section.description,
        })),
      },
      {
        "@type": "Article",
        "@id": guide.url,
        headline: guide.headline,
        description: guide.description,
        url: guide.url,
        inLanguage: "en",
        isAccessibleForFree: true,
        author: { "@id": "https://ahavibes.xyz/#founder" },
        publisher: { "@id": "https://ahavibes.xyz/#organization" },
        mainEntityOfPage: { "@type": "WebPage", "@id": guide.url },
        hasPart: guide.sections.map((section) => ({
          "@type": "WebPage",
          "@id": sectionUrl(section.id),
          name: section.name,
          description: section.description,
          url: sectionUrl(section.id),
          isAccessibleForFree: true,
        })),
      },
    ],
  };
}

export function buildGuideSectionJsonLd(guide, section) {
  const sectionUrl = `${guide.url}/${section.id}`;

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://ahavibes.xyz/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: guide.headline.split(":")[0],
            item: guide.url,
          },
          {
            "@type": "ListItem",
            position: 3,
            name: section.name,
            item: sectionUrl,
          },
        ],
      },
      {
        "@type": "Article",
        "@id": sectionUrl,
        headline: `${section.position}. ${section.name}`,
        description: section.description,
        url: sectionUrl,
        inLanguage: "en",
        isAccessibleForFree: true,
        isPartOf: { "@id": guide.url },
        author: { "@id": "https://ahavibes.xyz/#founder" },
        publisher: { "@id": "https://ahavibes.xyz/#organization" },
        mainEntityOfPage: { "@type": "WebPage", "@id": sectionUrl },
      },
    ],
  };
}
